import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { loadFormConfig2Data, loadFormConfig2DataSuccess, loadFormConfig2DataFailure } from '../actions/formConfig2.actions';
import { environment } from 'src/environments/environment';
import { selectFormConfig2Data } from '../selectors/formConfig2.selectors';
import { select, Store } from '@ngrx/store';

@Injectable()
export class FormConfig2Effects {
  loadFormConfig2Data$;
  constructor(private actions$: Actions, private http: HttpClient, private store: Store) {
    this.loadFormConfig2Data$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadFormConfig2Data),
        withLatestFrom(this.store.pipe(select(selectFormConfig2Data))),
        switchMap(([action, currentData]) => {
          console.log({currentData})
          if (currentData != undefined && Object.keys(currentData).length > 0) {
            console.log('Data already in store, no need to call API');
            console.log('return old fetch', new Date().toISOString())
            return;
          }
          const api = this.getApiEndpoint();
          const apiUrl = `${environment.apiUrl.replace(/\/$/, '')}${api}`;
          const headers = {
            'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}`,
            'Content-Type': 'application/json'
          };
          return this.http.get<any>(apiUrl, { headers }).pipe(
            map((data) => {
              console.log('Fetched new data:', data);
              console.log('new fetch', new Date().toISOString())
              return loadFormConfig2DataSuccess({ formConfig2Data: data.data });
            }),
            catchError((error) => {
              console.error('API Error:', error);
              const errorMessage = error?.message || 'An unknown error occurred';
              return [loadFormConfig2DataFailure({ error: errorMessage })]; // Dispatch failure on error
            })
          );
        })
      )
    );
  }

  private getApiEndpoint(): string {
    return `/api/ap/customer/formConfig_3`
    // https://testadminapi.groupbenefitz.aitestpro.com/api/ap/admin/corporateSignup/formConfig
  }
}
